import { Box, Grid, Typography, Button, Paper, Divider } from '@mui/material';
import FileUploader from './FileUploader'; // Make sure this exists

const ParticipantExit = ({ executionId, showAttachment, showClick }) => {
  return (
    <Paper
      elevation={4}
      sx={{
        maxWidth: 900,
        mx: 'auto',
        mt: 6,
        p: 4,
        borderRadius: 3,
        background: '#ffffff',
      }}
    >
      <Typography variant="h4" fontWeight="bold" gutterBottom color="primary">
        🚪 Participant Study Exit
      </Typography>

      <Divider sx={{ mb: 3 }} />

      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={7}>
          <Typography variant="h6" fontWeight="medium">
            📎 Would you like to add an attachment?
          </Typography>
        </Grid>
        <Grid item xs={12} md={5} display="flex" justifyContent="flex-end">
          <Button
            variant="contained"
            color="secondary"
            onClick={showClick}
            sx={{ minWidth: 120 }}
          >
            Add Attachment
          </Button>
        </Grid>
      </Grid>

      {showAttachment && (
        <Box mt={3}>
          <FileUploader obj_id={executionId} catog={3} />
        </Box>
      )}

      <Box mt={5} textAlign="center">
        <Button
          variant="contained"
          color="primary"
          sx={{
            width: 200,
            fontWeight: 'bold',
            fontSize: '1rem',
            boxShadow: 2,
          }}
          // onClick={handleSignOff}
        >
          ✅ Sign Off
        </Button>
      </Box>
    </Paper>
  );
};

export default ParticipantExit;
